var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpMainPageImgNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 260,
    height: 291.07,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.5 51.535)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206.038,
    height: 170.063,
    fill: "#b6edfd",
    rx: 6.541,
    transform: "translate(2.5 40.038)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00aff0",
    d: "M9.041 38.403H202a6.541 6.541 0 0 1 6.541 6.541v16.352H2.5V44.944a6.541 6.541 0 0 1 6.541-6.541Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.27,
    cy: 3.27,
    r: 3.27,
    fill: "#077cdb",
    transform: "translate(12.311 46.579)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.27,
    cy: 3.27,
    r: 3.27,
    fill: "#077cdb",
    transform: "translate(27.028 46.579)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.27,
    cy: 3.27,
    r: 3.27,
    fill: "#077cdb",
    transform: "translate(41.745 46.579)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00aff0",
    d: "M208.538 87.459V61.3h-75.22a6.541 6.541 0 0 1-6.541-6.541v-68.68a6.54 6.54 0 0 1 6.541-6.54h91.572a6.541 6.541 0 0 1 6.541 6.54v72.759a6.537 6.537 0 0 1-1.619 4.307Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#077cdb",
    d: "M202 38.4h-75.22v16.708a6.517 6.517 0 0 0 4.494 6.188h77.267V44.943A6.541 6.541 0 0 0 202 38.4ZM31.934 85.824h16.352v16.352H31.934z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64.638 85.824h112.83v4.906H64.638zM64.638 102.176h45.786v4.906H64.638z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#077cdb",
    d: "M31.934 164.314h16.352v16.352H31.934z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64.638 164.314h88.302v4.906H64.638zM64.638 180.667h45.786v4.906H64.638z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#077cdb",
    d: "M31.934 125.069h16.352v16.352H31.934z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64.638 125.069h112.83v4.906H64.638zM64.638 141.421h62.138v4.906H64.638z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00aff0",
    d: "M237.972 210.1v-16.352h-11.038a27.626 27.626 0 0 0-2.009-4.824l7.812-7.812-11.562-11.563-7.812 7.812a27.667 27.667 0 0 0-4.825-2.009v-11.038h-16.352v11.038a27.6 27.6 0 0 0-4.825 2.009l-7.812-7.812-11.563 11.563 7.812 7.812a27.625 27.625 0 0 0-2.009 4.824h-11.037V210.1h11.037a27.667 27.667 0 0 0 2.009 4.825l-7.812 7.811 11.563 11.564 7.812-7.812a27.6 27.6 0 0 0 4.825 2.009v11.038h16.352V228.5a27.667 27.667 0 0 0 4.825-2.009l7.812 7.812 11.562-11.563-7.812-7.811a27.668 27.668 0 0 0 2.009-4.825Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#077cdb",
    d: "M202 210.1a6.542 6.542 0 0 0 6.541-6.541v-39.245h-16.355v11.038a27.6 27.6 0 0 0-4.825 2.009l-7.812-7.812-11.563 11.563 7.812 7.812a27.625 27.625 0 0 0-2.009 4.824h-11.037V210.1H202Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.082,
    cy: 13.082,
    r: 13.082,
    fill: "#fff",
    transform: "translate(187.28 188.843)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.541,
    cy: 6.541,
    r: 6.541,
    fill: "#242529",
    transform: "translate(193.821 195.384)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#b6edfd",
    strokeMiterlimit: 10,
    strokeWidth: 9.811,
    d: "M165.83 14.067a13.274 13.274 0 1 1 13.27 13.274V38.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#242529",
    d: "M174.198 38.403h9.811v9.811h-9.811z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b6edfd",
    d: "M244.513-20.465H262.5v6.541h-17.987zM238.662-31.943l12.843-12.843 4.625 4.624-12.844 12.843zM224.89-51.535h6.541v17.987h-6.541z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpMainPageImgNew);
export default __webpack_public_path__ + "static/media/help-main-page-img-new.e49a607e2e55f5430ed269c7ab7454b0.svg";
export { ForwardRef as ReactComponent };